import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, switchMap, takeUntil } from 'rxjs/operators';
import { AcceptTerm, AcceptTermsService } from '../../services/accept-terms/accept-terms.service';
import { LoginStatusService } from '../../services/auth/login/login-status.service';
import { LoggedStatus } from '../../services/auth/login/login.models';

@Component({
  selector: 'app-accept-terms-notice',
  templateUrl: './accept-terms-notice.component.html',
  styleUrls: ['./accept-terms-notice.component.scss']
})
export class AcceptTermsNoticeComponent implements OnInit, OnDestroy {

  term: AcceptTerm;

  private pending: AcceptTerm[] = [];
  private unsubscribe = new Subject<void>();

  constructor(
    private acceptTermsService: AcceptTermsService,
    private loginStatusService: LoginStatusService,
  ) { }

  ngOnInit(): void {
    this.loginStatusService.getLoginStatus(false).pipe(
      filter(status => {
        if (status.isLogged !== LoggedStatus.notLogged) {
          this.term = null;
          this.pending = [];
        }
        return status.isLogged === LoggedStatus.notLogged;
      }),
      switchMap(() => this.acceptTermsService.getPendingTerms()),
      takeUntil(this.unsubscribe),
    ).subscribe(terms => {
      this.pending = terms;
      this.showNext();
    });
  }

  accept(): void {
    this.acceptTermsService.accept(this.term);
    this.showNext();
  }

  reject(): void {
    if (this.term.rejectRedirectUrl) {
      window.location.href = this.term.rejectRedirectUrl;
    }
  }

  private showNext(): void {
    this.term = this.pending.shift() || null;
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
